import { Box } from '@mui/material'
import HighlightChip from 'components/HighlightChip'
import utils from 'helpers/utils'
import { useSearchParams } from 'react-router-dom'
import { Product } from 'type/types'
import { ReactComponent as DiamondPurpleIcon } from 'assets/icons/diamondPurpleIcon.svg'
import { ReactComponent as BasicPlusBadgeIcon } from 'assets/icons/basicPlusBadgeIcon.svg'

type Props = {
  product: Pick<Product, 'id' | 'name' | 'nameFile' | 'visibility' | 'offer' | 'offer2'>
}

const SignUpProductPreview: React.FC<Props> = ({ product }) => {
  const [searchParams] = useSearchParams()

  const overrideDefaultSignupAction = searchParams.get('overrideDefaultSignupAction')
  const isContactSignUp = overrideDefaultSignupAction === 'CONTACT'

  if (!product) return null
  const { name, nameFile, visibility } = product

  return (
    <Box textAlign="center">
      <div style={{ height: 50 }} />
      <Box height="100px" mb="24px">
        {nameFile && (
          <Box display="flex" justifyContent="center">
            <Box position="relative">
              {visibility === 'PUBLIC' && (
                <Box position="absolute" left="80px" top="-10px">
                  <DiamondPurpleIcon height="30px" />
                </Box>
              )}
              {visibility === 'BASIC_PLUS' && (
                <Box position="absolute" left="80px" top="-10px">
                  <BasicPlusBadgeIcon height="30px" />
                </Box>
              )}
              <Box width={'100px'}>
                <img
                  src={utils.getUrlFileMedia(nameFile)}
                  alt={name}
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '18px',
                    border: '1px solid var(--black)',
                  }}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      {product.offer ? (
        <>
          <Box fontSize="21px">
            <h3 className="m-0 text-blue">{name}</h3>
            <Box display="flex" justifyContent="center" mt="8px">
              <HighlightChip>
                <strong>{product.offer}</strong>
              </HighlightChip>
            </Box>
            <Box mt="10px">
              <h3 className="m-0 text-dark-blue">
                {isContactSignUp ? <>Sign up to contact vendor</> : <>Sign up to get this offer!</>}
              </h3>
            </Box>
          </Box>
        </>
      ) : (
        <Box fontSize="21px">
          <h3 className="m-0 text-blue">{name}</h3>
          <h3 className="m-0 text-dark-blue">Sign up to {isContactSignUp ? 'contact' : 'subscribe'}</h3>
        </Box>
      )}
    </Box>
  )
}

export default SignUpProductPreview
